import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";
import SingleJob from "./layouts/SingleJob";

import imagePlaceholder from "../assets/img/user-placeholder.png";

function Recruiter() {
    const { id } = useParams();
    const [jobs, setJobs] = useState([]);
    const [company, setCompany] = useState(null);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [refetch, setRefetch] = useState(0);
    const [employees, setEmployees] = useState([]);
    const [totalEmployees, setTotalEmployees] = useState(0);

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("company_id", id);
            formData.append("time_zone", timeZone);
            formData.append("page", page);

            if (company == null) {
                formData.append("fetch_company", 1);
            }

            const response = await axios.post(
                baseUrl + "/api/jobs/search",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setJobs(response.data.jobs);
                setPages(response.data.pages);

                if (company == null) {
                    setCompany(response.data.company);
                    setEmployees(response.data.employees);
                    setTotalEmployees(response.data.total_employees);
                }
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        fetch();
    }, [refetch]);

    const styles = {
        numEmployees: {
            color: "darkgray",
            fontSize: "18px",
            fontStyle: "italic"
        }
    };

    return (
        <>
            {/*<div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">{ company?.name }</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/jobs">Jobs</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ company?.name }</li>
                        </ol>
                    </nav>
                </div>
            </div>*/}

            { loading && (
                <div className="row mt-5 mb-5">
                    <div className="col-md-12 text-center">
                        <Loader />
                    </div>
                </div>
            ) }

            { company != null && (
                <>
                    <div className="profile-header">
                        { company.cover_photo ? (
                            <img src={ company.cover_photo } alt={ company.name } className="cover" />
                        ) : (
                            <img src={ imagePlaceholder } alt={ company.name } className="cover" />
                        ) }
                        

                        <div className="overlay"></div>

                        <div className="profile-info">
                            { company.profile_image ? (
                                <img src={ company.profile_image } alt={ company.name } className="logo" />
                            ) : (
                                <img src={ imagePlaceholder } alt={ company.name } className="logo" />
                            ) }

                            <h1>{ company.name }</h1>
                        </div>
                    </div>

                    <div className="content">
                        <h2>Employees <span style={ styles.numEmployees }>({ totalEmployees })</span></h2>

                        <div className="employee-list mt-3">

                            { employees.map(function (emp, index) {
                                return (
                                    <div className="employee-card" key={ `employee-${ emp.id }` }>
                                        <img src={ emp.employee.profile_image } alt={ emp.employee.name } />
                                        <h3><Link to={ '/user/' + emp.employee.id }>{ emp.employee.name }</Link></h3>
                                    </div>
                                );
                            }) }
                        </div>
                    </div>
                </>
            ) }

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Job Listing</h1>

                    { jobs.map(function (j, index) {
                        return (
                            <SingleJob job={ j }
                                key={ `job-${ j.id }` } />
                        );
                    }) }

                    { pages > 1 && (
                        <nav className="mt-3">
                            <ul className="pagination">
                                { Array.from({ length: pages }, function (_, index) { return index + 1 } ).map(function (p) {
                                    return (
                                        <li key={ `pagination-${ p }` } className={ `page-item ${ p == page ? "active" : "" }` }>
                                            <a href="#" onClick={ function (event) {
                                                event.preventDefault();
                                                setPage(p);
                                                setRefetch(refetch + 1);
                                            } } className="page-link">{ p }</a>
                                        </li>
                                    );
                                }) }
                            </ul>
                        </nav>
                    ) }
                </div>
            </div>
        </>
    );
}

export default Recruiter;